import React from 'react';

import UcpDetailsList from './ucp-details-list';

import './ucp-details.scss';

interface UcpInfoProps {
  data: { refNumber: string; sum: string; link?: string }[];
  title?: React.ReactNode;
}

enum UcpInfoStrings {
  TITLE = 'Состав требования:',
}

const UcpInfo: React.FC<UcpInfoProps> = ({ data, title }) => (
  <div className="ucp-details">
    {title ? (
      title
    ) : (
      <h3 className="h3 ucp-details__title">{UcpInfoStrings.TITLE}</h3>
    )}
    <div className="ucp-details__header">
      <div className="ucp-details__header__item">Реализации</div>
      <div className="ucp-details__header__item">Цена</div>
    </div>
    <div className="ucp-details__list-wrapper">
      <UcpDetailsList data={data} />
    </div>
  </div>
);

export default UcpInfo;
